<template>
  <div ref="frame" class="thumbnail-item w-full relative aspect-video">
    <section
      :class="[
        'thumbnail-wrapper absolute top-0 left-0 w-full h-full overflow-hidden border border-gray-300',
        textContrastClass(slide.layout.background_color)
      ]"
      :style="{
        background: slide.layout.background_color,
        '--slide-width': `${SLIDE_WIDTH}px`,
        '--slide-height': `${SLIDE_HEIGHT}px`,
        '--thumbnail-scale': scale
      }"
    >
      <Slide
        :key="`thumbnail-${slide.id}`"
        :slide="slide"
        :is-thumbnail="true"
      />
    </section>
    <slot name="top-left"></slot>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import Slide from '../slides/Slide.vue'
import { textContrastClass } from '@/helpers'
import { SLIDE_WIDTH, SLIDE_HEIGHT } from '@/features/slides_editor/config/constants/slides'

defineProps({
  slide: {
    type: Object,
    required: true
  }
})

const frame = ref(null)
const scale = ref(0)
let observer = null

onMounted(() => {
  // Measured before the observer's first callback, which lands a frame later and
  // would otherwise draw every thumbnail at scale 0 on the way in.
  scale.value = frame.value.clientWidth / SLIDE_WIDTH
  observer = new ResizeObserver(([entry]) => {
    scale.value = entry.contentRect.width / SLIDE_WIDTH
  })
  observer.observe(frame.value)
})

onUnmounted(() => observer?.disconnect())
</script>

<style scoped>
.thumbnail-wrapper :deep(.actual-slide) {
  transform: scale(var(--thumbnail-scale));
  transform-origin: top left;
  width: var(--slide-width);
  height: var(--slide-height);
  pointer-events: none;
}
</style>
